import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import {
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";

type RightSidePreviewModalProps = {
  handleCancel: () => void;
  open: boolean;
  documentUrl: any;
};

const RightSidePreviewModal: React.FC<RightSidePreviewModalProps> = ({
  handleCancel,
  open,
  documentUrl,
}) => {
  const isPdf = documentUrl?.toLowerCase().endsWith(".pdf");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [rotationAngle, setRotationAngle] = useState(0);

  const handleZoomIn = () => setZoomLevel((prev) => Math.min(prev + 0.1, 3));
  const handleZoomOut = () => setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));
  const handleRotateLeft = () => setRotationAngle((prev) => prev - 90);
  const handleRotateRight = () => setRotationAngle((prev) => prev + 90);

  useEffect(() => {
    setZoomLevel(1);
    setRotationAngle(0);
  }, [documentUrl]);

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      width="90%"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: isPdf ? "flex-end" : "space-between",
            padding: "0 1rem",
          }}
        >
          {!isPdf && (
            <div>
              <Button
                onClick={handleZoomOut}
                disabled={zoomLevel <= 0.5}
                style={{ marginRight: 8 }}
              >
                <ZoomOutOutlined />
              </Button>
              <Button onClick={handleZoomIn} disabled={zoomLevel >= 3}>
                <ZoomInOutlined />
              </Button>
              <Button onClick={handleRotateLeft} style={{ marginLeft: 8 }}>
                <RotateLeftOutlined />
              </Button>
              <Button onClick={handleRotateRight} style={{ marginLeft: 8 }}>
                <RotateRightOutlined />
              </Button>
            </div>
          )}
          <Button onClick={handleCancel}>Cancel</Button>
        </div>
      }
      bodyStyle={{ height: "80vh", padding: 0, display: "flex", justifyContent: "center", alignItems: "center" }}
      centered
    >
      {isPdf ? (
        <object
          style={{ width: "100%", height: "100%" }}
          data={documentUrl}
          type="application/pdf"
        >
          <p>
            Unable to display the file.{" "}
            <a href={documentUrl} target="_blank" rel="noopener noreferrer">
              Click here to view it
            </a>
            .
          </p>
        </object>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1rem",
          }}
        >
          <div
            style={{
              display: "inline-block",
              transform: `rotate(${rotationAngle}deg)`,
              transformOrigin: "center center",
              transition: "transform 0.3s ease",
            }}
          >
            <img
              src={documentUrl!}
              alt="preview"
              style={{
                transform: `scale(${zoomLevel})`,
                display: "block",
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default RightSidePreviewModal;